import {
  COMPLIANCE_PORTAL_DEPLOYMENT_URLS,
  DeploymentType,
  DeploymentUrl,
  EnvironmentOrganization,
  GLOBAL_DASHBOARD_DEPLOYMENT_URLS,
  RECRUITMENT_PORTAL_DEPLOYMENT_URLS,
} from './organizations.environment';

export function getCompanyFromUrl(url: string): EnvironmentOrganization {
  const lowerUrl = url.toLowerCase();

  for (const env in COMPLIANCE_PORTAL_DEPLOYMENT_URLS) {
    if (!env) {
      continue;
    }
    for (const org in COMPLIANCE_PORTAL_DEPLOYMENT_URLS[
      env as DeploymentType
    ]) {
      if (
        lowerUrl.startsWith(
          COMPLIANCE_PORTAL_DEPLOYMENT_URLS[env as DeploymentType][
            org as EnvironmentOrganization
          ],
        )
      ) {
        return org as EnvironmentOrganization;
      }
    }
  }
  console.warn(`Could not determine company from url: ${url}, assuming TNS`);
  return 'tns';
}

export function getAuth0Organization(
  url: string,
  tnsOrg: string,
  sngOrg: string,
): string {
  const lowerUrl = url.toLowerCase();

  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.tns)
  )
    return tnsOrg;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production.sng) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat.sng) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa.sng) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development.sng) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.sng)
  )
    return sngOrg;

  return tnsOrg;
}

/**
 * Only for use in local environment.ts file when using "tns.localhost" or "sng.localhost"
 * @param {string} url `window.location.origin`
 * @returns {string} A local organisation redirect url
 */
export function getLocalAuth0SwapOrgUrl(url: string): string {
  const lowerUrl = url.toLowerCase();

  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.tns))
    return COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.sng;

  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.sng))
    return COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.tns;

  return url;
}

export function getRecruitmentPortalUrl(url: string): string {
  const lowerUrl = url.toLowerCase();

  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production.tns))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.production.tns;
  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat.tns))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.uat.tns;
  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa.tns))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.testa.tns;
  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development.tns))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.development.tns;
  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.tns))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.local.tns;

  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production.sng))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.production.sng;
  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat.sng))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.uat.sng;
  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa.sng))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.testa.sng;
  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development.sng))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.development.sng;
  if (lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.sng))
    return RECRUITMENT_PORTAL_DEPLOYMENT_URLS.local.sng;

  return url;
}

export function getGlobalDashboardUrl(url: string): string {
  const lowerUrl = url.toLowerCase();

  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production.sng)
  )
    return GLOBAL_DASHBOARD_DEPLOYMENT_URLS.production;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat.sng)
  )
    return GLOBAL_DASHBOARD_DEPLOYMENT_URLS.uat;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa.sng)
  )
    return GLOBAL_DASHBOARD_DEPLOYMENT_URLS.testa;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development.sng)
  )
    return GLOBAL_DASHBOARD_DEPLOYMENT_URLS.development;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.sng)
  )
    return GLOBAL_DASHBOARD_DEPLOYMENT_URLS.local;

  return GLOBAL_DASHBOARD_DEPLOYMENT_URLS.local;
}

export function getAuth0OrgErrorUrls(url: string): DeploymentUrl {
  const lowerUrl = url.toLowerCase();

  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production.sng)
  )
    return COMPLIANCE_PORTAL_DEPLOYMENT_URLS.production;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat.sng)
  )
    return COMPLIANCE_PORTAL_DEPLOYMENT_URLS.uat;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa.sng)
  )
    return COMPLIANCE_PORTAL_DEPLOYMENT_URLS.testa;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development.sng)
  )
    return COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development;
  if (
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.tns) ||
    lowerUrl.startsWith(COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local.sng)
  )
    return COMPLIANCE_PORTAL_DEPLOYMENT_URLS.local;

  return COMPLIANCE_PORTAL_DEPLOYMENT_URLS.development;
}
